// libs
import React, { memo, useState } from 'react';
import { useHistory, useParams } from 'react-router';

// global components
import RouteChunkRenderer from 'shared/components/RouteChunkRenderer';
import ChunkFallback from 'shared/components/ChunkFallback';

// components
import LandingPageMobile from 'shared/layouts/LandingPage/Mobile';
import LandingPageDesktop from 'shared/layouts/LandingPage/Desktop';

// helpers
import { getPageName } from './helpers';

function LandingPage() {
  const { slug } = useParams<{ slug: string }>();
  const { location } = useHistory();
  const [pageName] = useState(getPageName(location.search, slug));

  return (
    <RouteChunkRenderer
      mobileComponent={
        <LandingPageMobile pageName={pageName.mwebPageName} fallback={<ChunkFallback />} />
      }
      desktopComponent={
        <LandingPageDesktop pageName={pageName.dwebPageName} fallback={<ChunkFallback />} />
      }
    />
  );
}

export default memo(LandingPage);
